<script setup lang="ts">
/**
 * Thin wrapper autour de @donoor/ui.CampaignThankYouMessage.
 *
 * Le composant a été promu dans le package partagé pour éliminer la
 * duplication avec dashboard. On garde ce fichier local pour profiter
 * de l'auto-import Nuxt sans toucher aux ~10+ usages dans les pages.
 *
 * Le slot `#icon` reçoit le <UIcon> spécifique à Nuxt UI 3.3 (donoor.org).
 *
 * Cf. ADR-009 Z0.8.
 */
import { CampaignThankYouMessage } from "@donoor/ui";

defineProps<{
  message: string;
}>();
</script>

<template>
  <CampaignThankYouMessage :message="message">
    <template #icon>
      <UIcon
        name="i-lucide-heart"
        class="size-6 text-primary-600 dark:text-primary-400"
      />
    </template>
  </CampaignThankYouMessage>
</template>
